export default __webpack_public_path__ + "static/media/unlock-potential-banner.f0912543.webp";